$('.js-accordion-trigger').on('click', function(event) {
  event.preventDefault();
  const $this = $(this);
  $this
    .next()
    .slideToggle(500)
    .parent()
    .toggleClass('is-open')
      .siblings()
      .removeClass('is-open')
      .find('.accordion__body')
      .slideUp(500);
});